<template>
  <div
      :is="driver + '-form'"
      v-model="data"
      :errors="errors"
      :portal="portal"
  />
</template>

<script>
import CallToActionForm
  from '@/components/Panels/Administration/MarketingSites/Blocks/DriverForms/CallToAction'
import CenteredQuoteForm
  from '@/components/Panels/Administration/MarketingSites/Blocks/DriverForms/CenteredQuote'
import CompanyLogosForm
  from '@/components/Panels/Administration/MarketingSites/Blocks/DriverForms/CompanyLogos'
import EmployeeListForm
  from '@/components/Panels/Administration/MarketingSites/Blocks/DriverForms/EmployeeList'
import FeatureForm from '@/components/Panels/Administration/MarketingSites/Blocks/DriverForms/Feature'
import GalleryForm from '@/components/Panels/Administration/MarketingSites/Blocks/DriverForms/Gallery'
import HeadlineForm from '@/components/Panels/Administration/MarketingSites/Blocks/DriverForms/Headline'
import HeroForm from '@/components/Panels/Administration/MarketingSites/Blocks/DriverForms/Hero'
import ImageForm from '@/components/Panels/Administration/MarketingSites/Blocks/DriverForms/Image'
import LargeImageQuoteForm
  from '@/components/Panels/Administration/MarketingSites/Blocks/DriverForms/LargeImageQuote'
import LatestArticleListForm
  from '@/components/Panels/Administration/MarketingSites/Blocks/DriverForms/LatestArticleList'
import LegalTextForm
  from '@/components/Panels/Administration/MarketingSites/Blocks/DriverForms/LegalText'
import PriceTableForm from '@/components/Panels/Administration/MarketingSites/Blocks/DriverForms/PriceTable'
import ProjectListForm from '@/components/Panels/Administration/MarketingSites/Blocks/DriverForms/ProjectList'
import PublicationAdFormatListForm
  from '@/components/Panels/Administration/MarketingSites/Blocks/DriverForms/PublicationAdFormatList'
import PublicationListForm
  from '@/components/Panels/Administration/MarketingSites/Blocks/DriverForms/PublicationList'
import StatisticsForm from '@/components/Panels/Administration/MarketingSites/Blocks/DriverForms/Statistics'
import TextForm from '@/components/Panels/Administration/MarketingSites/Blocks/DriverForms/Text'
import TimeAdFormatListForm
  from '@/components/Panels/Administration/MarketingSites/Blocks/DriverForms/TimeAdFormatList'

export default {
  components: {
    CallToActionForm,
    CenteredQuoteForm,
    CompanyLogosForm,
    EmployeeListForm,
    FeatureForm,
    GalleryForm,
    HeadlineForm,
    HeroForm,
    ImageForm,
    LargeImageQuoteForm,
    LatestArticleListForm,
    LegalTextForm,
    PriceTableForm,
    ProjectListForm,
    PublicationAdFormatListForm,
    PublicationListForm,
    StatisticsForm,
    TextForm,
    TimeAdFormatListForm
  },

  props: {
    driver: {
      required: true
    },

    value: {
      required: true
    },

    errors: {
      required: true
    },

    portal: {
      required: true
    }
  },

  computed: {
    data: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
